export default __webpack_public_path__ + "static/media/signin.6217b3a5.png";